"use client";
/* eslint-disable */

import { useCallback } from "react";
import { API_URL } from "../config";
import { RequestConfigType } from "./types/request-config";
import useFetch from "../use-fetch";
import wrapperFetchJsonResponse from "../wrapper-fetch-json-response";
import useAuthTokens from "~/services/auth/use-auth-tokens";
import useUserId from "~/hooks/useUserId";
import type { SurveySchema } from "~/types/Survey";

export type QuestionnaireSaveAnswerResponse = void;

type InnerResult = Record<string, string | number>;
type Result = {
    [key: string]: InnerResult | string;
};

export type SurveysSaveAnswerRequest = {
    surveyId: string;
    answer: {
        userId: string | undefined;
        result: Result;
    };
};

export function useSurveysSaveAnswerService() {
    const fetchBase = useFetch();
    const { tokensInfoRef } = useAuthTokens();
    const { userId } = useUserId();
    const isAuth = tokensInfoRef.current?.token;
    const query = isAuth ? "answer" : "guest-answer";

    return useCallback(
        (data: SurveysSaveAnswerRequest, requestConfig?: RequestConfigType) => {
            return fetchBase(`${API_URL}/v1/surveys/${data?.surveyId}/${query}/${userId}`, {
                method: "POST",
                body: JSON.stringify(data.answer),
                ...requestConfig,
            }).then(wrapperFetchJsonResponse<QuestionnaireSaveAnswerResponse>);
        },
        [ isAuth]
    );
}

export type FetchSurveyServiceResponse = {
    id?: string;
    schema?: SurveySchema;
    [key: string]: unknown;
};

export function useFetchSurveyService() {
    const fetchBase = useFetch();

    return useCallback(
        (category = "") => {
            const params = category ? `?category=${category}` : "";
            return fetchBase(`${API_URL}/v1/surveys/client-questionnaire${params}`, {
                method: "GET",
            }).then(wrapperFetchJsonResponse<FetchSurveyServiceResponse>);
        },
        [fetchBase]
    );
}
/* eslint-enable */
